import React, { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridContainer from "../../components/Grid/GridContainer.js";
import Button from "../../components/CustomButtons/Button.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";
import { grayColor } from "../../assets/jss/material-dashboard-react";
import { ToastContainer } from "react-toastify";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { showWarningToast } from "../../utils/toastMessages";
import { getRankedAlternatives } from "../../api/rankingApi";
import { isRealNumber } from "../../utils/isNumber";
import CriteriaValuesForAlternatives from "../../components/CriteriaValuesForAlternative/CriteriaValuesForAlternatives";

const styles = (theme) => ({
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  cardTitle: {
    color: grayColor[2],
    marginTop: "0px",
    minHeight: "auto",
    fontSize: "12px",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "0px",
    textDecoration: "none",
    paddingBottom: "20px",
  },
  cardCategory: {
    color: grayColor[0],
    margin: "0",
    fontSize: "16px",
    marginTop: "0",
    paddingTop: "10px",
    marginBottom: "0",
  },
  description: {
    marginTop: "2px",
    marginBottom: "0",
    textAlign: "justify",
  },
  rowReverseMd: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "row-reverse",
    },
  },
  matrixCell: {
    margin: "2px",
    width: "6%",
    fontSize: "12px",
  },
  matrixRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "start",
    paddingBottom: "2px",
  },
  dropdown: {
    width: "100px",
    fontSize: "12px",
    margin: "2px",
    padding: "2px",
  },
  alternativeInput: {
    margin: "2px",
    width: "15%",
    fontSize: "12px",
  },
  labelTxt: {
    margin: "2px",
    padding: "4px",
    flex: "0 0 15%",
    fontSize: "12px",
  },
  criteriaInput: {
    margin: "2px",
    width: "92px",
    fontSize: "12px",
    padding: "2px",
  },
  criteriaRow: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  matrixContainer: {
    overflowX: "auto",
    paddingBottom: "5px",
  },
});

const useStyles = makeStyles(styles);

export default function MatrixForm(props) {
  const classes = useStyles();
  const {
    alternativesNum,
    criteriaNum,
    criteria,
    onNext,
    onBack,
    alternativesNames,
  } = props;
  const [matrix, setMatrix] = useState([]);
  const [criteriaSelected, setCriteriaSelected] = useState([]);
  const history = useHistory();
  const componentsArray = Array.from({ length: criteriaNum });

  const [rankedAlternatives, setRankedAlternatives] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const initialMatrix = Array.from(
      { length: parseInt(alternativesNum) },
      () => Array(parseInt(criteriaNum)).fill(NaN)
    );
    setMatrix(initialMatrix);
    setCriteriaSelected(Array(parseInt(criteriaNum)).fill(-1));
  }, [alternativesNum, criteriaNum]);

  function handleMatrixChange(row, col, value) {
    setMatrix((prevMatrix) => {
      const newMatrix = [...prevMatrix];
      newMatrix[row] = [...newMatrix[row]];
      newMatrix[row][col] = parseFloat(value);

      return newMatrix;
    });
  }

  const handleCriteriaChange = (index, value) => {
    const newSelectedCriteria = [...criteriaSelected];
    newSelectedCriteria[index] = parseInt(value);
    setCriteriaSelected(newSelectedCriteria);
  };


  const goToResults = (result) => {
    history.push("/admin/results", { matrix, rankedAlternatives: result, criteriaSelected: criteriaSelected, alternativesNames: alternativesNames});
  };

  const rankAlternatives = async () => {
    setLoading(true);
    try {
      const body = {
        alternativesNames,
        criteriaSelected,
        matrix,
      };

      const result = await getRankedAlternatives(body);
      setRankedAlternatives(result);
      goToResults(result);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleRank = () => {
    if (criteriaSelected.includes(-1)) {
      showWarningToast({
        title: "Izaberite kriterijume!",
        message: `Morate izabrati ${criteriaNum} kriterijuma!`,
      });
      return;
    }

    if (criteriaSelected.length !== new Set(criteriaSelected).size) {
      showWarningToast({
        title: "Izabran isti kriterijumi više puta!",
        message: "Svi kriterijumi moraju biti različiti!",
      });
      return;
    }

    for (let i = 0; i < alternativesNum; i++) {
      for (let j = 0; j < criteriaNum; j++) {
        if (!isRealNumber(matrix[i][j])) {
          showWarningToast({
            title: "Nepotpun unos!",
            message: "Moraju biti popunjena sva polja!",
          });
          return;
        }
      }
    }
    rankAlternatives();
  };

  const renderMatrix = () => {
    if (matrix.length === 0 || alternativesNames.length === 0) {
      return null;
    }

    return (
      <div className={classes.matrixContainer}>
        <GridContainer>
          {componentsArray.map((_, index) => (
            <CriteriaValuesForAlternatives
              key={index}
              numAlternatives={alternativesNum}
              alternativesNames={alternativesNames}
              criteria={criteria}
              numCriteria={index}
              handleMatrixChange={handleMatrixChange}
              handleCriteriaChange={handleCriteriaChange}
            ></CriteriaValuesForAlternatives>
          ))}
        </GridContainer>
      </div>
    );
  };

  return (
    <div>
      <Card>
        <CardHeader color="success">
          <h4 className={classes.cardTitleWhite}>Unos podataka</h4>
          <p className={classes.cardCategoryWhite}>Težinski koeficijenti</p>
        </CardHeader>
        <CardBody>
          <ToastContainer />
          {renderMatrix()}
        </CardBody>
        <CardFooter>
          <Button color="success" onPress={onBack}>
            Nazad
          </Button>
          <Button color="success" onPress={handleRank}>
            Rangiraj
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}

